/*
These functions make sure WordPress
and Foundation play nice together.
*/

(function($) {

	$(document).ready(function() {
		
	    // Remove empty P tags created by WP inside of Accordion and Orbit
	    $('.accordion p:empty, .orbit p:empty').remove();

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			  $(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
			  $(this).wrap("<div class='responsive-embed'/>");
			}
		});
	}); 
	$('.aboutModal-toggle').click(function() {
		$('#aboutModal').foundation('toggle');
	});
	$('.slick-quotes').slick({
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  autoplay: true,
	  autoplaySpeed: 5000
	});

	$('.slick-media-mentions').slick({
	  infinite: true,
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  arrows: false,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 4
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 2
	      }
	    }
	  ]
	});

	$('.slick-resources').slick({
	  infinite: true,
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  arrows: false,
	  responsive: [
	    {
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1
	      }
	    }
	  ]
	});

	$('.rm-click-prev').click(function() {
	  var navWrapper = $(this).closest('.rm-slick-nav');
	  var slickSlider;
	  if ( $(navWrapper).hasClass('bottom-nav') ) {
	    slickSlider = $(navWrapper).prev('.slick-slider');
	  } else {
	    slickSlider = $(navWrapper).next('.slick-slider');
	  }
	  $(slickSlider).slick('slickPrev');
	});
	$('.rm-click-next').click(function() {
	  var navWrapper = $(this).closest('.rm-slick-nav');
	  var slickSlider;
	  if ( $(navWrapper).hasClass('bottom-nav') ) {
	    slickSlider = $(navWrapper).prev('.slick-slider');
	  } else {
	    slickSlider = $(navWrapper).next('.slick-slider');
	  }
	  $(slickSlider).slick('slickNext');
	});
})(jQuery);